import { SUBCLUSTERS } from '../subclusters.js';

const OTHER_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.BUSINESS_OPERATIONS,
        },
        {
            key: SUBCLUSTERS.CLIENT_PROJECTS,
        },
        {
            key: SUBCLUSTERS.CONTENT_CALENDAR,
        },
        {
            key: SUBCLUSTERS.EVENT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.DIGITAL_ASSET_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.STRATEGIC_PLANNING,
        },
        {
            key: SUBCLUSTERS.SALES_PIPELINE,
        },
        {
            key: SUBCLUSTERS.CONTACT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.PROJECT_PLANNING,
        },
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
        {
            key: SUBCLUSTERS.SOFTWARE_DEVELOPMENT,
        },
    ],
};

export { OTHER_CLUSTER };
